module.exports = __webpack_public_path__ + "img/footer-background.47920690.png";